import { createContext } from "react";
import type { SelectContextType, SelectDescendantsContextType } from "./types";

export const SelectDescendentsContext =
	createContext<SelectDescendantsContextType>(undefined as never);

export const SelectContext = createContext<SelectContextType>(
	undefined as never,
);
